export const AlchemyActionTriggers = ["onClick", "onHover"] as const;
export type AlchemyActionTrigger = (typeof AlchemyActionTriggers)[number];
